import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import BackButtonIcon from './BackIconComponent';
import { t } from 'i18next';

const ButtonObelisk = ({
  children,
  disabled,
  color,
  onClick,
  variant,
  type,
  m,
  p,
  sx,
  mw,
  loading,
  className,
  combined,
  size,
  uppercase,
  px,
}) => {
  const defaultSx = {
    transition: '0.3s all ease-in-out',
    marginTop: m !== undefined ? m : 4,
    marginBottom: m !== undefined ? m : 4,
    marginLeft: { xs: 0, sm: m !== undefined ? m : 4 },
    marginRight: { xs: 0, sm: m !== undefined ? m : 4 },
    p: p !== undefined ? p : 1.5,
    paddingLeft: px !== undefined ? px : 3,
    paddingRight: px !== undefined ? px : 3,
    textTransform: uppercase ? 'uppercase' : 'none',
    width: { xs: '100%', sm: 'auto' },
    minWidth: mw !== undefined ? mw : { xs: 0, sm: '14em' },
    fontSize: {
      xs: size === 'small' ? '1em' : size === 'large' ? '1.5em' : '1.2em',
      sm: size === 'small' ? '0.75em' : size === 'large' ? '1.2em' : '0.95em',
    },
  };
  return (
    <Button
      className={className || ''}
      disabled={disabled || loading}
      variant={variant || 'contained'}
      color={color || 'primary'}
      type={type || 'button'}
      sx={sx ? { ...(combined ? defaultSx : {}), ...sx } : defaultSx}
      // onClick={typeof onClick === 'function' ? () => onClick() : () => {}}
      onClick={typeof onClick === 'function' ? (e) => onClick(e) : undefined}
    >
      {children}
      {loading && (
        <>
          &nbsp;
          <CircularProgress size={24} />
        </>
      )}
    </Button>
  );
};

ButtonObelisk.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.string,
  type: PropTypes.string,
  m: PropTypes.number,
  p: PropTypes.number,
  mw: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  sx: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  combined: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.string,
  px: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  uppercase: PropTypes.bool,
};

export default ButtonObelisk;

export const ButtonBack = ({ className }) => {
  const navigate = useNavigate();
  return (
    <Link
      style={{ marginRight: '5px' }}
      onClick={() => navigate(-1)}
      className='btn btn-default '
    >
      <BackButtonIcon />
      <span className={className || ''}>{t('return')}</span>
    </Link>
  );
};

ButtonBack.propTypes = {
  className: PropTypes.string,
};
